const SET_SPECIALTY_OPTIONS = "SET_SPECIALTY_OPTIONS";

export const setSpecialtyOptions = (payload) => {
    return {
        type: SET_SPECIALTY_OPTIONS,
        payload,
    };
};

const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_SPECIALTY_OPTIONS:
            if (!action.payload) {
                return initialState;
            }
            return [...action.payload];

        default:
            return state;
    }
};
